function StatusPill({ children, tone = "default" }) {
  const className = tone === "danger"
    ? "inline-flex rounded-full bg-red-500/15 px-2.5 py-1 text-xs font-semibold text-red-200"
    : "inline-flex rounded-full bg-cyan-300/10 px-2.5 py-1 text-xs font-semibold text-cyan-200";

  return (
    <span className={className}>
      {children}
    </span>
  );
}

export default StatusPill;
